var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 55,
    viewBox: "0 0 27 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9865 26.4348C14.9865 23.8261 15.0126 21.1652 15.0647 18.4522C15.1169 15.7391 15.1952 13.4174 15.2995 11.487H15.143C13.943 12.687 11.7256 14.5913 8.49081 17.2L5.67342 19.4696L0.27342 12.113L16.1604 0.37391H26.0995V55H14.9865V26.4348Z",
    fill: "#0B5ED7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.2237989abd923bdc07fc96260aa3accb.svg";
export { ForwardRef as ReactComponent };